import { render, staticRenderFns } from "./RelocationModal.vue?vue&type=template&id=56b317fa&"
import script from "./RelocationModal.vue?vue&type=script&lang=js&"
export * from "./RelocationModal.vue?vue&type=script&lang=js&"
import style0 from "./RelocationModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports